// extracted by mini-css-extract-plugin
export default {"project-sidebar":"ProjectLayout_project-sidebar__5YAYa","project-layout":"ProjectLayout_project-layout__CCj41","project-content":"ProjectLayout_project-content__x5LqC"};